function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.link.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
/* eslint-disable react/prop-types */
import React, { useContext } from 'react';
import FontAwesome from 'react-fontawesome';
import SweetAlert from 'sweetalert-react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Box, FormControlLabel, Grid, Switch, Tooltip, useId } from '@applyboard/ui-components';
import { notesReceivedAction } from "../../../store/actions/application";
import { applicationNotesArray } from "../../../store/selectors/application";
import useDispatch from "../../../hooks/useDispatch";
import { useUpdateNote } from "../../../data/notes";
import raiseSuccessMessage from "../../../util/raiseSuccessMessage";
import raiseErrorMessage from "../../../util/raiseErrorMessage";
import { useInitialProps } from "../../../hooks/useInitialProps";
import { getApplicationStatusMessage } from "../../../util/common";
import User from "./User";
import RawHtml from "../../RawHtml";
import ReadBy from "./ReadBy";
import { API_ROOT } from "../../../constants/consts";
import { useEventTracker, UserContext } from '@applyboard/ui-utils';
import { _ActionsContainer, ActionIconButton, _AttachmentsWrapper, _Note, _NoteContainer, _NoteMessage, _NoteTitleContainer } from "../styles";
import { _Attachment, _Attachments, _AttachmentsTitle } from "../../style";
import { Markdown } from '@applyboard/crystal-ui';
var Note = function Note(_ref) {
  var _note$author, _note$author2, _note$author3, _note$author4, _note$body, _note$author5, _note$author6, _note$author7, _note$author8;
  var batchSendPermission = _ref.batchSendPermission,
    cancelonDelete = _ref.cancelonDelete,
    confirmonDelete = _ref.confirmonDelete,
    deletePermission = _ref.deletePermission,
    displayAttachments = _ref.displayAttachments,
    hideCopy = _ref.hideCopy,
    hideReply = _ref.hideReply,
    isInternal = _ref.isInternal,
    isPrivate = _ref.isPrivate,
    note = _ref.note,
    noteCreatedAt = _ref.noteCreatedAt,
    onBatchSend = _ref.onBatchSend,
    onCopyToClipboard = _ref.onCopyToClipboard,
    onDelete = _ref.onDelete,
    onDeleteAlertShow = _ref.onDeleteAlertShow,
    onReply = _ref.onReply,
    readInfo = _ref.readInfo,
    readTooltip = _ref.readTooltip,
    scrollNoteId = _ref.scrollNoteId,
    userPermissions = _ref.userPermissions;
  var _useInitialProps = useInitialProps(),
    application = _useInitialProps.application;
  var currentUser = useContext(UserContext);
  var _useEventTracker = useEventTracker({
      data: {
        role: currentUser.role,
        applicationStage: application === null || application === void 0 ? void 0 : application.current_stage,
        applicationStatus: getApplicationStatusMessage(application)
      }
    }),
    trackEvent = _useEventTracker.trackEvent;
  var showResolveSwitch = !isInternal && (userPermissions === null || userPermissions === void 0 ? void 0 : userPermissions.view_note_resolution_status);
  return /*#__PURE__*/React.createElement(_Note, {
    id: "note-".concat(note.id),
    isInternal: isInternal,
    scrolltoNote: String(scrollNoteId) === String(note.id)
  }, isInternal && /*#__PURE__*/React.createElement(User, {
    image: note === null || note === void 0 ? void 0 : (_note$author = note.author) === null || _note$author === void 0 ? void 0 : _note$author.profile_picture,
    firstName: note === null || note === void 0 ? void 0 : (_note$author2 = note.author) === null || _note$author2 === void 0 ? void 0 : _note$author2.first_name,
    lastName: note === null || note === void 0 ? void 0 : (_note$author3 = note.author) === null || _note$author3 === void 0 ? void 0 : _note$author3.last_name,
    email: note === null || note === void 0 ? void 0 : (_note$author4 = note.author) === null || _note$author4 === void 0 ? void 0 : _note$author4.email,
    id: "note-".concat(note.id)
  }), /*#__PURE__*/React.createElement(_NoteContainer, {
    scrolltoNote: String(scrollNoteId) === String(note.id),
    className: note && note.restricted ? 'restricted' : null
  }, /*#__PURE__*/React.createElement(_NoteTitleContainer, {
    isPrivate: isPrivate,
    isInternal: isInternal,
    className: "note-header"
  }, /*#__PURE__*/React.createElement("div", {
    "data-testid": "note-title"
  }, note && note.restricted ? /*#__PURE__*/React.createElement("span", null, "Private") : null, note.title), /*#__PURE__*/React.createElement(_ActionsContainer, null, noteCreatedAt, !hideCopy && /*#__PURE__*/React.createElement(ActionIconButton, {
    "aria-label": "Copy to clipboard",
    onClick: onCopyToClipboard
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    "aria-hidden": true,
    name: "link"
  })), !hideReply && /*#__PURE__*/React.createElement(ActionIconButton, {
    "aria-label": "Reply note",
    onClick: function onClick() {
      trackEvent({
        event: "Single Application - ".concat(isPrivate ? 'Admin Comments' : 'Notes', " - Clicked Reply to Note")
      });
      onReply();
    }
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    "aria-hidden": true,
    name: "reply"
  })), isInternal && /*#__PURE__*/React.createElement(React.Fragment, null, batchSendPermission && /*#__PURE__*/React.createElement(ActionIconButton, {
    "aria-label": "Share note",
    disabled: !(!note.attachments || note.attachments.length <= 0),
    onClick: !note.attachments || note.attachments.length <= 0 ? function () {
      trackEvent({
        event: "Single Application - ".concat(isPrivate ? 'Admin Comments' : 'Notes', " - Clicked Forward Note")
      });
      onBatchSend();
    } : null
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    name: "share-square",
    disabled: !(!note.attachments || note.attachments.length <= 0),
    "data-tip": !note.attachments || note.attachments.length <= 0 ? null : 'Batch sending notes with attachments is not permitted'
  }))), deletePermission && /*#__PURE__*/React.createElement(ActionIconButton, {
    "aria-label": "Delete note",
    onClick: onDelete
  }, /*#__PURE__*/React.createElement(FontAwesome, {
    "aria-hidden": true,
    name: "trash"
  })))), /*#__PURE__*/React.createElement(_NoteMessage, {
    attachments: displayAttachments,
    className: "note-body"
  }, note.content_encoding === 'markdown' ? /*#__PURE__*/React.createElement(Markdown, {
    markdown: (_note$body = note.body) !== null && _note$body !== void 0 ? _note$body : '',
    headingSettings: {
      baseLevel: 3,
      styles: {
        h1: {
          variant: 'bodyM',
          contrast: 'mid',
          bold: true
        }
      }
    }
  }) : /*#__PURE__*/React.createElement(RawHtml, {
    html: note.body
  })), displayAttachments && /*#__PURE__*/React.createElement(_AttachmentsWrapper, null, /*#__PURE__*/React.createElement(_AttachmentsTitle, null, /*#__PURE__*/React.createElement(FontAwesome, {
    name: "paperclip"
  }), /*#__PURE__*/React.createElement("span", null, "Attachments (", note.attachments.length, "):")), /*#__PURE__*/React.createElement(_Attachments, null, note.attachments.map(function (_ref2) {
    var id = _ref2.id,
      link = _ref2.link,
      file_name = _ref2.file_name,
      file_path = _ref2.file_path;
    return /*#__PURE__*/React.createElement(_Attachment, {
      key: "note-attachment-".concat(id)
    }, /*#__PURE__*/React.createElement("a", {
      href: "".concat(API_ROOT).concat(link || file_path),
      target: "_tab"
    }, /*#__PURE__*/React.createElement("span", null, file_name)));
  }))), /*#__PURE__*/React.createElement(Grid, {
    container: true
  }, showResolveSwitch && /*#__PURE__*/React.createElement(ResolveSwitch, {
    note: note,
    userPermissions: userPermissions
  }), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: showResolveSwitch ? 5 : 12
  }, /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    height: "100%",
    flexDirection: "column",
    justifyContent: "flex-end"
  }, /*#__PURE__*/React.createElement(ReadBy, {
    readInfo: readInfo,
    readTooltip: readTooltip
  }))))), !isInternal && /*#__PURE__*/React.createElement(User, {
    image: note === null || note === void 0 ? void 0 : (_note$author5 = note.author) === null || _note$author5 === void 0 ? void 0 : _note$author5.profile_picture,
    firstName: note === null || note === void 0 ? void 0 : (_note$author6 = note.author) === null || _note$author6 === void 0 ? void 0 : _note$author6.first_name,
    lastName: note === null || note === void 0 ? void 0 : (_note$author7 = note.author) === null || _note$author7 === void 0 ? void 0 : _note$author7.last_name,
    email: note === null || note === void 0 ? void 0 : (_note$author8 = note.author) === null || _note$author8 === void 0 ? void 0 : _note$author8.email,
    id: "note-".concat(note.id)
  }), /*#__PURE__*/React.createElement(SweetAlert, {
    confirmButtonText: "Delete",
    onCancel: cancelonDelete,
    onClose: cancelonDelete,
    onConfirm: confirmonDelete,
    onEscapeKey: cancelonDelete,
    show: onDeleteAlertShow,
    showCancelButton: true,
    text: "Are you sure you want to delete this note?",
    title: "",
    type: "warning"
  }));
};
var ResolveSwitch = connect(createStructuredSelector({
  applicationNotes: applicationNotesArray
}))(function (_ref3) {
  var applicationNotes = _ref3.applicationNotes,
    note = _ref3.note,
    userPermissions = _ref3.userPermissions;
  var dispatch = useDispatch();
  var _useUpdateNote = useUpdateNote(),
    updateNote = _useUpdateNote.updateNote,
    isUpdatingNote = _useUpdateNote.isUpdatingNote;
  var tooltipId = useId();
  return /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    sm: 7
  }, /*#__PURE__*/React.createElement(Tooltip, {
    title: userPermissions !== null && userPermissions !== void 0 && userPermissions.update_note_resolution_status ? '' : /*#__PURE__*/React.createElement("span", {
      id: tooltipId
    }, "This switch is disabled because you have \u201Cview only\u201D access.")
  }, !(userPermissions !== null && userPermissions !== void 0 && userPermissions.update_note_resolution_status) && /*#__PURE__*/React.createElement(Box, {
    "aria-describedby": tooltipId,
    tabIndex: 0,
    "data-testid": "".concat(tooltipId, "-tooltip-trigger"),
    "aria-label": note.resolved ? 'Resolved' : 'Unresolved'
  }), /*#__PURE__*/React.createElement(FormControlLabel, {
    ml: 1,
    label: note.resolved ? 'Resolved' : 'Unresolved',
    control: /*#__PURE__*/React.createElement(Switch, {
      color: "primary",
      checked: !!note.resolved,
      disabled: isUpdatingNote || !(userPermissions !== null && userPermissions !== void 0 && userPermissions.update_note_resolution_status),
      onClick: function onClick() {
        updateNote({
          id: note.id,
          resolved: !note.resolved
        }, {
          onSuccess: function onSuccess(updatedNote) {
            var updatedNotes = applicationNotes.map(function (note) {
              return note.id.toString() === updatedNote.id.toString() ? _objectSpread(_objectSpread({}, note), {}, {
                resolved: updatedNote.resolved
              }) : note;
            });
            dispatch(notesReceivedAction(updatedNotes));
            raiseSuccessMessage("Note set to ".concat(updatedNote.resolved ? 'resolved' : 'unresolved', " successfully."));
          },
          onError: function onError(error) {
            if (error instanceof Error) {
              raiseErrorMessage(error.message);
            }
          }
        });
      }
    }),
    labelPlacement: "end"
  })));
});
Note.propTypes = {
  batchSendPermission: PropTypes.bool,
  cancelonDelete: PropTypes.func,
  confirmonDelete: PropTypes.func,
  deletePermission: PropTypes.bool,
  displayAttachments: PropTypes.bool,
  hideAlertForonDelete: PropTypes.func,
  isInternal: PropTypes.bool.isRequired,
  isPrivate: PropTypes.bool.isRequired,
  note: PropTypes.shape({
    attachments: PropTypes.array,
    author: PropTypes.shape({
      email: PropTypes.string.isRequired,
      first_name: PropTypes.string,
      id: PropTypes.number.isRequired,
      last_name: PropTypes.string,
      staff: PropTypes.bool.isRequired
    }),
    body: PropTypes.string,
    created_at: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    title: PropTypes.string,
    visibility: PropTypes.string.isRequired,
    resolved: PropTypes.bool
  }),
  noteCreatedAt: PropTypes.string,
  noteUrl: PropTypes.string,
  onCopyToClipboard: PropTypes.func,
  onDelete: PropTypes.func,
  onDeleteAlertShow: PropTypes.bool,
  onReply: PropTypes.func,
  scrollNoteId: PropTypes.string,
  userPermissions: PropTypes.object
};
export default Note;